module.exports = __webpack_public_path__ + "img/icon_exchange.2a3da400.svg";